import { ISMT_DotTaoDe_Request } from "../../../model/request/de-thi/ISMT_DotTaoDe_Request";
import { ISMT_DotTaoDe } from "../../../model/respone/de-thi/ISMT_DotTaoDe";
import { IDotTaoDeActionTypes } from "../../action-types/de-thi/IDotTaoDeActions";
import { IDotTaoDeReducer } from "../../reducer-model/de-thi/IDotTaoDeReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IDotTaoDeReducer = {
  status: eReducerStatusBase.is_not_initialization,
  idSelections: [],
  dotTaoDeEditing: {} as ISMT_DotTaoDe,
  dotTaoDes: [],
  request: {
    id_dot_thi: 0,
    id_mon: 0,
    type: 1,
  } as ISMT_DotTaoDe_Request,
};

export const dotTaoDeReducer = (
  state: IDotTaoDeReducer = iniState,
  action: IDotTaoDeActionTypes
): IDotTaoDeReducer => {
  switch (action.type) {
    case "DOT_TAO_DE_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "DOT_TAO_DE_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        dotTaoDes: action.payload,
      };
    case "DOT_TAO_DE_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DOT_TAO_DE_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "DOT_TAO_DE_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "DOT_TAO_DE_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DOT_TAO_DE_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "DOT_TAO_DE_DELETE_SUCCESS":
      return {
        ...state,
        idSelections: [],
        status: eReducerStatusBase.is_need_reload,
      };
    case "DOT_TAO_DE_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DOT_TAO_DE_SHOW_EDIT_MODAL":
      return {
        ...state,
        dotTaoDeEditing: action.payload,
        isShowEditModal: true,
      };
    case "DOT_TAO_DE_CLOSE_EDIT_MODAL":
      return {
        ...state,
        dotTaoDeEditing: undefined,
        isShowEditModal: false,
      };
    case "DOT_TAO_DE_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "DOT_TAO_DE_CHANGE_REQUEST":
      const isDifferent =
        JSON.stringify(action.payload) !== JSON.stringify(state.request);
      if (isDifferent)
        return {
          ...state,
          request: {
            ...state.request,
            ...action.payload,
          },
          status: eReducerStatusBase.is_need_reload,
        };
      return state;
    case "DOT_TAO_DE_CLOSE_PROCESSING_MODAL":
      return {
        ...state,
        isShowProcessing: false,
      };
    case "DOT_TAO_DE_CREATE_DETHI_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        processId: action.payload.process_id,
        isShowProcessing: true,
      };
    case "DOT_TAO_DE_CREATE_DETHI_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "DOT_TAO_DE_CREATE_DETHI_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DOT_TAO_DE_DELETE_MULTIPLE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "DOT_TAO_DE_DELETE_MULTIPLE_SUCCESS":
      return {
        ...state,
        idSelections: [],
        status: eReducerStatusBase.is_need_reload,
      };
    case "DOT_TAO_DE_DELETE_MULTIPLE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
